import useGoogleMapsAutocompleteService from '~/src/hooks/google-maps/useGoogleMapsAutocompleteService'
import { useState } from 'react'

type ValidateAddressObject = {
  street: string | undefined,
  zipcode: string | undefined,
  locality: string | undefined,
  country: string | undefined,
}

interface ReturnsType {
  isLoading: boolean,
  validate(address: ValidateAddressObject): Promise<boolean>,
}

const useValidateAddressWithGoogle = (): ReturnsType => {
  const [ isLoading, setIsLoading ] = useState<boolean>(false)
  const autocompleteService = useGoogleMapsAutocompleteService()

  const validate = async ({ street, zipcode, locality, country }: ValidateAddressObject): Promise<boolean> => {
    if (!street || !zipcode || !locality || !country || !autocompleteService) {
      return false
    }

    try {
      setIsLoading(true)

      const results: google.maps.places.AutocompleteResponse = await autocompleteService.getPlacePredictions({
        input: `${street}, ${zipcode} ${locality}, ${country}`
      })

      return results.predictions.some((prediction: google.maps.places.AutocompletePrediction) => {
        const description: string = prediction.description.toLowerCase()

        return description.includes(street.toLowerCase())
          && description.includes(zipcode.toLowerCase())
          && description.includes(locality.toLowerCase())
      })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    validate
  }
}

export default useValidateAddressWithGoogle
